// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__fe69a0118116d25928af","cls2":"UserTooltip-cls2___3b88c5e61d659e80ab3 UserTooltip-cls1__fe69a0118116d25928af"};